import {Component, EventEmitter, Input, Output} from '@angular/core';
import {GroupEsolverResult} from '../../_models/GroupEsolverResult';
import {OrdineEsolver} from '../../_models/OrdineEsolver';
import {Subscription} from 'rxjs';
import {OrganizzazioniService} from '../../_services/organizzazioni.service';
import {Organizzazione} from '../../_models/Organizzazione';

@Component({
  selector: 'app-ordine-esolver-groupbymany-item',
  templateUrl: './ordine-esolver-groupbymany-item.component.html',
  styleUrls: ['./ordine-esolver-groupbymany-item.component.scss'],
  standalone: false
})
export class OrdineEsolverGroupbymanyItemComponent {
  @Input() ordineEsolverGroupByMany: GroupEsolverResult<OrdineEsolver>;
  @Input() level: number;
  @Output() ordiniEsolverAddSended = new EventEmitter<OrdineEsolver[]>();
  isVisibleOrdiniEsolver = false;
  today = new Date();
  subscription: Subscription;
  groupColumns = [];

  constructor(
    private organizzazioniService: OrganizzazioniService) {
    this.groupColumns = this.organizzazioniService.groupColumnsLabelArray;
    this.subscription = this.organizzazioniService.currentOrganizzazione
      .subscribe((_org: Organizzazione) => {
        this.groupColumns = this.organizzazioniService.groupColumnsLabelArray;
      });
  }

  isOverdue(dt: any): boolean {
    return new Date(dt).getTime() < this.today.getTime();
  }

  showOrdiniEsolver = () => this.isVisibleOrdiniEsolver = !this.isVisibleOrdiniEsolver;
  addOrdiniEsolver = (ordiniEsolver: OrdineEsolver[]) => this.ordiniEsolverAddSended.emit(ordiniEsolver);
}
